/**
 * Tab Component - Created by david on 26/02/18.
 */
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Container, Text, Icon } from './styledComponents'

interface Props {
  label: string
  icon: string
  color?: string
}

const Tab = ({ label, icon, color }: Props) => {
  return (
    <Container>
      <Icon src={icon} />
      <Text {...{ color }}>
        <FormattedMessage {...messages[label]} />
      </Text>
    </Container>
  )
}

export default Tab



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/Tab/index.tsx